/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipDidsAPI extends WhatsAppSipApiClient {
  constructor() {
    super('dids');
  }

  get() {
    return axios.get(this.url);
  }

  show(id) {
    return axios.get(`${this.url}/${encodeURIComponent(id)}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.put(`${this.url}/${encodeURIComponent(id)}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${encodeURIComponent(id)}`);
  }
}

export default new WhatsAppSipDidsAPI();
